import reducer from "./reducer";
export { default as ExternalDocuments } from "./components/index";
export { default as externalDocumentsReducerName } from "./constants";
export default reducer;
